<template>
  <div>
    <b-modal
      size="xl"
      centered
      hide-footer
      title="Criando Notificação"
      header-bg-variant="orange"
      header-text-variant="light"
      v-model="open"
    >
      <b-container>
        <b-row>
          <b-col cols="12" md="4" class="mt-md-5">
            <h5 class="text-center">Simulação da notificação</h5>
            <img
              class="img-responsive img-fluid mt-4"
              src="@/assets/img/mockups/iphone-firebase.png"
              width="350px"
              style="min-height: 200px; max-height: 200px"
            />
            <b-container class="notification-text">
              <b-row class="mx-0">
                <b-col cols="12">
                  <div>{{ fields.title ? limitText(fields.title) : 'Titulo' }}</div>
                  <div>{{ fields.text ? limitText(fields.text) : 'Texto contendo a mensagem' }}</div>
                </b-col>
                <!-- <b-col cols="2" align-self="center">
                  <i class="fas fa-image fs-30"></i>
                </b-col> -->
              </b-row>
            </b-container>
          </b-col>

          <b-col cols="12" md="8" class="mt-4 mt-lg-0">
            <b-row>
              <b-col cols="12" class="mt-4 mt-lg-0">
                <h5 class="text-center mt-5 mt-lg-0">Dados da notificação</h5>
              </b-col>
              <b-col cols="12" class="mt-2">
                <b-form-group
                  id="title-notification"
                  label="Titulo da notificação:"
                  label-for="title-notification"
                >
                  <b-form-input
                    id="title-notification"
                    v-model="fields.title"
                    type="text"
                    placeholder="Insira um titulo opcional"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  id="text-notification"
                  label="Texto da notificação:"
                  label-for="text-notification"
                >
                  <b-form-input
                    id="text-notification"
                    v-model="fields.text"
                    type="text"
                    placeholder="Insira o texto da notificação"
                    required
                  ></b-form-input>
                </b-form-group>

                <!-- <b-form-group
                  id="image"
                  label="Imagem da notificação:"
                  label-for="image"
                >
                  <b-form-file
                    v-model="image"
                    placeholder="Faça o upload da imagem opcional"
                    @input="addImage()"
                  ></b-form-file>
                </b-form-group> -->
              </b-col>
              <!-- <b-col cols="12" class="mt-3">
                <h5 class="text-center">Programaçao de envio</h5>
                
                <div>
                  <b-form-group label="Quando enviar a notificação?" v-slot="{ ariaDescribedby }">
                    <b-form-radio-group
                      v-model="selected"
                      :options="options"
                      :aria-describedby="ariaDescribedby"
                      button-variant="outline-primary"
                      name="radios-btn-default"
                      buttons
                    ></b-form-radio-group>
                  </b-form-group>
                </div>

                <div v-if="selected == 'program'" class="d-flex justify-content-around mt-3">
                  <b-form-datepicker
                    v-model="dateNotification" 
                    reset-button
                    close-button
                    today-button
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                    placeholder="Data"
                    label-close-button="Fechar"
                    label-today-button="Hoje"
                    label-reset-button="Limpar"
                    locale="pt-BR"
                  />

                  <b-form-timepicker 
                    class="timer-heigth ml-4"
                    v-model="timerNotification" 
                    locale="pt-BR"
                    close-button
                    now-button
                    reset-button
                    placeholder="Hora"
                    label-close-button="Fechar"
                    label-now-button="Agora"
                    label-reset-button="Resetar"
                  >
                  </b-form-timepicker>
                </div>
              </b-col> -->
            </b-row>
          </b-col>
          
          <b-col cols="12" class="d-flex justify-content-end mt-4">
            <b-button 
              variant="danger"
              @click="closeModal()"
            >
            <i class="fas fa-ban mr-2"></i>
              Cancelar
            </b-button>

            <b-button 
              variant="success"
              class="ml-4"
              @click="sendNotification()"
            >
            <i class="fas fa-paper-plane mr-2"></i>
              Enviar Notificação
            </b-button>

          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import makeToast from '@/mixins/makeToast';

export default {
  mixins: [makeToast],
  emits: ['send'],

  data() {
    return {
      open: false,
      dateNotification: null,
      timerNotification: null,
      image: null,
      fields: {
        title: null,
        text: null,
        date_send: null,
        image: null,
        construp_user_id: null,
      },
      selected: 'now',
      options: [
        { text: 'Enviar Agora', value: 'now' },
        // { text: 'Programar Envio', value: 'program' },
      ]
    }
  },

  methods: {
    toggleOpen(idUser) {
      this.open = !this.open;
      this.fields.construp_user_id = idUser;
      this.cleanFields();
    },
    closeModal() {
      this.open = false;
    },
    cleanFields() {
      this.fields.title = null;
      this.fields.text = null;
      this.image = null;
      this.fields.date_send = null;
    },
    sendNotification() {
      if(!this.fields.text) {
        this.makeToast(
          'Erro',
          'Campo do texto é obrigatório!',
          'danger'
        );
        return
      }
     
      if(this.selected == 'program'){
        if(!this.dateNotification || !this.timerNotification) {
          this.makeToast(
            'Erro',
            'Favor preencher a data e hora para envio da notificação!',
            'danger'
          );
        return
        }

        this.fields.date_send = this.dateNotification + ' '+ this.timerNotification;
      }

      this.$emit('send', this.fields);
      this.closeModal();
    },
    limitText(text) {
      return text.length <= 30 ? text : text.slice(0, 30) + "...";
    },
  }
}
</script>

<style scoped>

.notification-text {
  margin-top: -120px;
  margin-left: 5px;
}
</style>